import { connect } from 'react-redux';
import Violation from './Violation';
import { getViolationColumnFields } from 'src/store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const violationColumnFields = getViolationColumnFields(state);
    return {
        violationColumnFields,
    };
};

export default connect(mapStateToProps)(Violation);
